// Centralised, typed access to Vite env vars.
// All public env vars MUST be prefixed VITE_ and are baked into the client bundle.
//
// Firebase config is deliberately NOT here: it is fetched at runtime from
// GET /firebase-config (see api/firebase.ts). Service workers cannot read
// import.meta.env, and baking it in meant a build without env files shipped a
// silently broken bundle.

interface Env {
  apiBaseUrl: string;
  mobileAppToken: string;
}

function required(name: string, value: string | undefined, fallback = ''): string {
  if (!value) {
    if (import.meta.env.PROD) {
      console.warn(`[env] Missing ${name}; using fallback`);
    }
    return fallback;
  }
  return value;
}

export const env: Env = {
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL, '/api'),
  mobileAppToken: required('VITE_MOBILE_APP_TOKEN', import.meta.env.VITE_MOBILE_APP_TOKEN),
};
